// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"ToggleButton_toggleButton__2gKLR","selected":"ToggleButton_selected__30TcO"};